/**
 * CloseIcon Component
 * 
 * This component renders close Icon for autocomplete field
 * 
 * */
import React from 'react';
import { Icon } from './AutoComplete.styled';
import Close from 'src/assets/images/CloseProduct.svg';

export default function CloseIcon(props) {
    const {height, disabled, onChange, onClose} = props;
    return ( 
        <Icon
        id="autocomplete-close-icon"
            src={Close}
            height={height}
            onClick={() => {
                !disabled
                    ? onChange(
                            '',
                            true
                        )
                    : null;
                onClose &&
                    onClose();
            }}
            opacity={
                disabled
                    ? '0.5'
                    : '1'
            }
        /> 
    );
}